export default {
    index(type) {
        return axios.get(`/frontend/address/${type}`)
    }
}
